/* Seoul House — display-only currency converter.
   Store settles in SAR (Tap gateway). This only changes how prices are SHOWN
   while browsing; the cart/checkout always charge in SAR. Prices are converted
   from the authoritative `data-base-cents` (integer SAR cents) stamped server-side,
   so we never parse localized text. GCC currencies are USD-pegged, so static
   cross-rates are stable. */
window.SeoulHouse = window.SeoulHouse || {};
(function (SH) {
  // SAR -> target multiplier (via USD pegs: SAR 3.75, AED 3.6725, QAR 3.64,
  // KWD 0.307, BHD 0.376, OMR 0.3845), display decimals, and labels.
  const CUR = {
    SAR: { rate: 1,        dec: 2, code: 'SAR', ar: 'ر.س' },
    AED: { rate: 0.97933,  dec: 2, code: 'AED', ar: 'د.إ' },
    QAR: { rate: 0.97067,  dec: 2, code: 'QAR', ar: 'ر.ق' },
    KWD: { rate: 0.081867, dec: 3, code: 'KWD', ar: 'د.ك' },
    BHD: { rate: 0.100267, dec: 3, code: 'BHD', ar: 'د.ب' },
    OMR: { rate: 0.102533, dec: 3, code: 'OMR', ar: 'ر.ع' },
  };
  const KEY = 'sh-currency';
  const isEn = () => (document.documentElement.lang || 'ar').startsWith('en');
  const current = () => (CUR[localStorage.getItem(KEY)] ? localStorage.getItem(KEY) : 'SAR');
  const label = (code) => (isEn() ? CUR[code].code : CUR[code].ar);

  function fmt(baseCents, code) {
    const c = CUR[code];
    const amount = (baseCents / 100) * c.rate;
    const s = amount.toLocaleString('en-US', { minimumFractionDigits: c.dec, maximumFractionDigits: c.dec });
    return `${s} ${label(code)}`;
  }

  function convertAll(root) {
    const code = current();
    (root || document).querySelectorAll('[data-base-cents]').forEach((el) => {
      const cents = parseInt(el.getAttribute('data-base-cents'), 10);
      if (!isNaN(cents)) el.textContent = fmt(cents, code);
    });
  }

  function updateNotices() {
    const code = current();
    document.querySelectorAll('[data-currency-notice]').forEach((n) => {
      n.hidden = code === 'SAR';
      n.textContent = isEn()
        ? `Prices shown in ${code}. You will be charged in SAR at checkout.`
        : `الأسعار معروضة بعملة ${label(code)}. سيتم تحصيل المبلغ بالريال السعودي (SAR) عند الدفع.`;
    });
  }

  function refreshMenus() {
    const code = current();
    document.querySelectorAll('[data-currency-current]').forEach((el) => { el.textContent = label(code); });
    document.querySelectorAll('[data-currency-menu] [data-currency]').forEach((b) => {
      const active = b.getAttribute('data-currency') === code;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function setCurrency(code) {
    if (!CUR[code]) code = 'SAR';
    localStorage.setItem(KEY, code);
    convertAll();
    updateNotices();
    refreshMenus();
  }

  SH.currency = { convertAll, setCurrency, current, CUR };

  function init() {
    document.querySelectorAll('[data-currency-menu]').forEach((menu) => {
      const trigger = menu.querySelector('.currency-menu__trigger');
      const list = menu.querySelector('.currency-menu__list');
      if (!trigger || !list) return;
      const close = () => { list.hidden = true; trigger.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); };
      const open = () => { list.hidden = false; trigger.setAttribute('aria-expanded', 'true'); menu.classList.add('is-open'); };
      trigger.addEventListener('click', (e) => { e.stopPropagation(); if (list.hidden) open(); else close(); });
      list.querySelectorAll('[data-currency]').forEach((btn) => {
        btn.addEventListener('click', () => { setCurrency(btn.getAttribute('data-currency')); close(); });
      });
      document.addEventListener('click', (e) => { if (!menu.contains(e.target)) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    });
    refreshMenus();
    convertAll();
    updateNotices();
    // Re-convert prices injected after load (quick-add, cart suggestions, pagination).
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-base-cents]')) convertAll(node.parentNode);
          else if (node.querySelector && node.querySelector('[data-base-cents]')) convertAll(node);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window.SeoulHouse);
